module.exports = __webpack_public_path__ + "img/c-11.de6def46.jpg";